import React from 'react';
import { UserModel } from '../../../../../interfaces/user.interface';
import { BookModel } from '../../../../../interfaces/book.interface';
import Logo from '../../../../Admin/logo.webp';
import { getCurrentYear } from '../../../../../helper/helper';
import { ListViewMode } from '../../ListViewModeSwitcher';

interface BookContentProps {
  mode: ListViewMode;
  bookData: BookModel;
  user: UserModel | null;
}

const BookContent: React.FC<BookContentProps> = ({ mode, bookData, user }: BookContentProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mx-0 lg:mx-2">
      {mode === ListViewMode.PAGE ? (
        <>
          <div
            className={` h-[350px] w-[350px]  md:w-[600px] md:h-[600px] flex flex-col rounded-lg mx-auto py-3 bg-gray-200 ${'mb-4 ml-[3rem] mt-[1rem] lg:mx-auto lg:mt-0'} `}
            style={{
              backgroundImage: `url("/paper.jpg")`,
              backgroundSize: 'cover'
            }}
          >
            <div
              className="flex flex-col justify-center items-center p-5 md:px-16 md:py-8 gap-16 md:gap-44">
              <h3 className="text-center text-lg md:text-2xl bold font-yuji-boku">{bookData?.title}</h3>
              <div>
                <p className="text-xs md:text-base text-justify font-poppins mb-2 md:mb-8">
                  All rights reserved. No part of the publication may be reproduced, stored in or
                  introduced
                  into a retrieval system, or trasmitted, in any form, or by any means
                  (electronic,
                  mechanica, photocopying, recording or otherwise) without the prior written
                  permission of
                  the author.
                </p>
                <p className="text-xs md:text-base text-justify font-poppins">
                  Any person who does any unauthorized act in relation to this publication may be
                  liable to
                  criminal prosecution ad civil claims for damages. Text and illustrations
                  copyright &#169;{' '}
                  {user?.firstName} {user?.lastName} {getCurrentYear()} Moral rights asserted.
                </p>
              </div>
            </div>
            <div className="w-full flex flex-col   items-center gap-1">
              <div className="flex items-baseline gap-1">
                <img className="h-3 md:h-6 w-auto" src={Logo} alt="Build My Story" />
              </div>
            </div>
          </div>
          <div
            className={` h-[350px] w-[350px]  md:w-[600px] md:h-[600px] flex flex-col rounded-lg ml-[3.5rem] mr-[.5rem] lg:mx-auto  bg-gray-200 ${'mb-4 '} `}
          >
            <div
              style={{
                height: '100%',
                width: '100%',
                backgroundImage: `url('paper.jpg')`,
                backgroundSize: 'cover',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src={Logo} alt="logo" style={{ height: '4rem', margin: 'auto' }} />
            </div>
          </div>
        </>
      ) : (
        <div
          className="flex flex-col md:flex md:flex-row md:justify-center gap-[1rem] lg:gap-4 p-0 md:py-4 rounded  xs:flex-wrap ">
          <div
            className=" h-72 w-72 flex flex-col justify-around rounded-lg mx-0 mx-auto sm:mx-0 lg:mx-auto py-3 bg-gray-200"
            style={{
              backgroundImage: `url("/paper.jpg")`,
              backgroundSize: 'cover'
            }}
          >
            <div className="flex flex-col justify-center items-center pt-4 pb-2 px-5 gap-8">
              <h3 className="text-center text-lg bold font-yuji-boku">{bookData?.title}</h3>
              <div className=" ">
                <p className="leading-[12px] text-[10px] text-justify font-poppins mb-1">
                  All rights reserved. No part of the publication may be reproduced, stored in or
                  introduced
                  into a retrieval system, or trasmitted, in any form, or by any means
                  (electronic,
                  mechanica, photocopying, recording or otherwise) without the prior written
                  permission of
                  the author.
                </p>
                <p className="leading-[12px] text-[10px] text-justify  font-poppins">
                  Any person who does any unauthorized act in relation to this publication may be
                  liable to
                  criminal prosecution ad civil claims for damages. Text and illustrations
                  copyright &#169;{' '}
                  {user?.firstName} {user?.lastName} {getCurrentYear()} Moral rights asserted.
                </p>
              </div>
            </div>
            <div className="w-full flex flex-col items-center gap-1">
              <div className="flex items-baseline gap-1">
                <img className="h-3 md:h-6 w-auto" src={Logo} alt="Build My Story" />
              </div>
            </div>
          </div>
          {/* Company Page */}
          <div
            className="h-72 w-72 flex flex-col justify-center rounded-lg mx-0 mx-auto sm:mx-0 lg:mx-auto py-3 bg-gray-200"
            style={{
              backgroundImage: `url("/paper.jpg")`,
              backgroundSize: 'cover'
            }}
          >
            {/*<div className="flex flex-col justify-center items-center p-5 gap-2 "></div>*/}
            <div className="w-full flex flex-col items-center gap-1">
              <div className="flex items-baseline gap-1">
                <img className="h-4 md:h-8 w-auto" src={Logo} alt="Build My Story" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookContent;
